const SITE_URL = "https://rkinfosys.com";
const DEFAULT_IMAGE = `${SITE_URL}/assets/images/hero/home-img1.jpg`;
const SITE_NAME = "RK Infosys";

export const seoConfig = {
  home: {
    title:
      "RK Infosys - Software Development, Web Design, Mobile App Development & Internship Programs",
    description:
      "RK Infosys offers custom software development, web design, mobile app development, internship programs, and project training. Expert developers delivering innovative digital solutions.",
    keywords:
      "internship, internship in navsari,software development, web design, mobile app development, project training, custom software, frontend development, backend development",
    path: "/",
    image: DEFAULT_IMAGE,
  },
  about: {
    title: "About RK Infosys - Custom Software Development Company Since 2021",
    description:
      "Learn about RK Infosys, a software development company founded in 2021. We deliver custom software, web design, mobile apps, internship programs, and project training.",
    keywords:
      "about RK Infosys, software development company, custom software, web design company, mobile app development, internship programs",
    path: "/about",
    image: `${SITE_URL}/assets/images/hero/about.jpeg`,
  },
  services: {
    title:
      "Our Services - Frontend, Backend, Mobile App & Web Design | RK Infosys",
    description:
      "Explore RK Infosys services: frontend development, backend development, mobile app development, web design, custom software, internship programs, and project training.",
    keywords:
      "frontend development, backend development, mobile app development, web design, custom software development, internship programs, project training",
    path: "/services",
    image: `${SITE_URL}/assets/images/services/s1.png`,
  },
  contact: {
    title: "Contact RK Infosys - Software Development & Digital Solutions",
    description:
      "Get in touch with RK Infosys for custom software development, web design, and mobile app solutions. Located in Navsari, Gujarat. Call 8758444957 or email rkinfosys19@gmail.com.",
    keywords:
      "contact RK Infosys, software development contact, Navsari software company, web design inquiry, mobile app development quote",
    path: "/contact",
    image: `${SITE_URL}/assets/images/hero/contact.jpg`,
  },
};

export { SITE_URL, SITE_NAME, DEFAULT_IMAGE };
